const BEAT_MS = 400;
const MIN_CURTAIN_MS = 900;
/** Matches RoomDirector's boot transition so the slam lands as the black lifts. */
const HIDE_AFTER_BEGIN_MS = 350;
/** Title screen fold before the cinematic fades in over it. */
const CARD_FOLD_MS = 380;
/** After the cinematic: curtain whoosh starts at 0, beat text lands here, gates slam as the whoosh bolts home. */
const BEAT_AFTER_CINEMATIC_MS = 250;
const SLAM_AFTER_CINEMATIC_MS = 750;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

export interface OpeningCurtain {
  boot: HTMLElement;
  beat: HTMLElement;
  /** Story cold open. Resolves when it ends or the player skips. Omit for the plain curtain. */
  cinematic?: (() => Promise<void>) | undefined;
  /** Curtain whoosh plus the arena music; fires as the black hold begins. */
  handoff: () => void;
  begin: () => void;
}

/**
 * Title-to-arena curtain, run after the start screen has taken the player's
 * gesture and locked in a tier: boot layer folds to black, the Arcane Broadcast
 * cinematic plays (skippable), black hold, "GATES ARE LOCKED", then the run
 * starts under the fade.
 */
export async function playOpeningCurtain(opts: OpeningCurtain): Promise<void> {
  opts.boot.classList.add('leaving');

  if (opts.cinematic) {
    await sleep(CARD_FOLD_MS);
    await opts.cinematic().catch(() => undefined);
    opts.handoff();
    window.setTimeout(() => opts.beat.classList.add('show'), BEAT_AFTER_CINEMATIC_MS);
    await sleep(SLAM_AFTER_CINEMATIC_MS);
  } else {
    opts.handoff();
    window.setTimeout(() => opts.beat.classList.add('show'), BEAT_MS);
    await sleep(MIN_CURTAIN_MS);
  }

  try {
    opts.begin();
  } catch (err) {
    console.warn('opening begin failed', err);
    throw err;
  }
  await sleep(HIDE_AFTER_BEGIN_MS);
  opts.boot.classList.add('hidden');
}
